module.exports = "<div fxLayout=\"column\" fxLayoutAlign=\"start start\">\n  <p class=\"mat-headline\">\n    {{card.question}}\n  </p>\n  <!--<img [src]=\"'assets/images/' + card.id.toString() + '.png'\" *ngIf=\"card.questionImage\">-->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/remote/card/question/card-question.component.html
// module id = ./src/app/remote/card/question/card-question.component.html
// module chunks = main